import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

export const getLeaveRequests = (params: any = {}) => {
  const query = new URLSearchParams();
  for (const key in params) {
    if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
      query.set(key, params[key]);
    }
  }
  const queryString = query.toString();
  return api.get(
    `${BASE_URL}/api/v1/leave-requests${queryString ? `?${queryString}` : ""}`
  );
};

export const createLeaveRequest = (payload: {
  clinicUserId: number;
  leaveTypeId?: number;
  startDate: string;
  endDate: string;
  startHalf?: string;
  endHalf?: string;
  reason?: string;
}) => {
  return api.post(
    `${BASE_URL}/api/v1/leave-requests`,
    camelToSnake(payload)
  );
};
